import * as XLSX from 'xlsx'
import moment from 'moment'

export function exportPriceItems() {
    const calculateModulesDimension = ({ quote, impactLouvers }) => {
        const newData = {
            column1: quote.language.toLowerCase() == 'english' ? 'Pos' : 'Pos',
            column2:
                quote.language.toLowerCase() == 'english'
                    ? 'Material/Description'
                    : 'Material/Descripción',
            column3:
                quote.language.toLowerCase() == 'english'
                    ? 'Quantity'
                    : 'Cantidad',
            column4: quote.language.toLowerCase() == 'english' ? 'UM' : 'UM',
            column5:
                quote.language.toLowerCase() == 'english'
                    ? 'Unit Price'
                    : 'Precio Unitario',
            column6:
                quote.language.toLowerCase() == 'english'
                    ? 'Entry date'
                    : 'Fecha de entrada',
            column7:
                quote.language.toLowerCase() == 'english'
                    ? 'Net Price'
                    : 'Valor Neto',
            items: impactLouvers.map((item, index) => {
                return {
                    position: index + 1,
                    material_description: item.lineItemName,
                    quantity: item.louverQuantity,
                    um: 'UN',
                    unit_price: item.netEachPrice,
                    entry_date: moment
                        .unix(
                            quote.estimatedExecDate.seconds ||
                                quote.estimatedExecDate._seconds
                        )
                        .format('DD-MM-YYYY'),
                    net_price: item.netEachPrice * item.louverQuantity,
                }
            }),
        }
        return newData
    }

    const exportToExcel = ({ quote, impactLouvers, fileName }) => {
        try {
            const data = calculateModulesDimension({ quote, impactLouvers })
            // Crear un nuevo libro de trabajo
            const wb = XLSX.utils.book_new()
            // Preparar los encabezados principales
            const mainHeaders = [
                data.column1,
                data.column2,
                data.column3,
                data.column4,
                data.column5,
                data.column6,
                data.column7,
            ]

            // Preparar los datos de las filas
            const rowsData = data.items.map(item => [
                item.position,
                item.material_description,
                item.quantity,
                item.um,
                item.unit_price,
                item.entry_date,
                item.net_price,
            ])

            // Combinar todo en un solo array
            const wsData = [mainHeaders, ...rowsData]

            // Crear la hoja de trabajo
            const ws = XLSX.utils.aoa_to_sheet(wsData)

            // Aplicar estilos y ajustar anchos de columna
            const colWidths = [
                { wch: 12 }, // Position
                { wch: 20 }, // Material/Description
                { wch: 18 }, // Quantity
                { wch: 18 }, // UM
                { wch: 16 }, // Unit Price
                { wch: 16 }, // Entry date
                { wch: 12 }, // Net Price
            ]
            ws['!cols'] = colWidths

            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(wb, ws, 'Price Items Schedule')

            // Generar el archivo y descargarlo
            const resolvedFileName =
                fileName || `Price_Items_Schedule_${quote.number || ''}.xlsx`

            // Generar el archivo en memoria como Blob para subirlo a Firebase
            const excelBuffer = XLSX.write(wb, {
                type: 'array',
                bookType: 'xlsx',
            })
            const blob = new Blob([excelBuffer], {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            const file = new File([blob], resolvedFileName, {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })

            return { file, fileName: resolvedFileName }
        } catch (error) {
            console.error('Export error:', error)
            throw error
        }
    }

    return {
        exportToExcel,
    }
}
